module.exports = __webpack_public_path__ + "static/media/downloader.c720c422.jpg";